import { mapState, mapMutations } from 'vuex';

import Button from '@components/ui/button.vue';
import SingUp from '@components/right-menu/ui/singup.vue';
import SingIn from '@components/right-menu/ui/singin.vue';
import Feedback from '@components/right-menu/ui/feedback.vue';
import FeedbackOwner from '@components/right-menu/ui/feedbackOwner.vue';
import Passwordrecovery from '@components/right-menu/ui/passwordrecovery.vue';
import Fastbuy from '@components/right-menu/ui/fastbuy.vue';
import Confirm from '@components/right-menu/ui/confirmBlock.vue';
import Changepassword from '@components/right-menu/ui/changepassword.vue';
import CodeConfirm from '@components/right-menu/ui/codeconfirm.vue';
import notSingIn from '@components/right-menu/ui/notSingIn.vue';
import MobilApp from '@components/right-menu/ui/mobileApp.vue';
import CallBackForm from '@components/right-menu/ui/callback.vue';
import NewPassword from '@components/right-menu/ui/newpassword.vue';

export default {
  components: {
    't-button': Button,
    't-sing-up': SingUp,
    't-fast-buy-menu': Fastbuy,
    't-sing-in': SingIn,
    't-password-recovery': Passwordrecovery,
    't-feedback': Feedback,
    't-feedback-owner': FeedbackOwner,
    't-confirm': Confirm,
    't-change-password': Changepassword,
    't-code-confirm': CodeConfirm,
    't-not-sing-in': notSingIn,
    't-mobile-app': MobilApp,
    't-call-back-form': CallBackForm,
    't-new-password-block': NewPassword,
  },
  computed: {
    ...mapState('params', [
      'rightMenu',
      'singup',
      'singin',
      'fastbuy',
      'passwordrecovery',
      'feedback',
      'feedbackOwner',
      'confirmBlock',
      'changePassword',
      'codeConfirm',
      'notSingIn',
      'firstStart',
      'callBackForm',
      'newPasswordBlock',
    ]),
  },
  methods: {
    ...mapMutations('params', ['toggleRightMenu']),
    click: function() {
      this.toggleRightMenu();
    },
  },
};



// WEBPACK FOOTER //
// ./src/templates/components/right-menu/script.js